export interface SupabaseConfig {
  url: string
  anonKey: string
}

const DEVELOPMENT: SupabaseConfig = {
  url: 'https://qgmsycavewajuhslwxzi.supabase.co',
  anonKey:
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFnbXN5Y2F2ZXdhanVoc2x3eHppIiwicm9sZSI6ImFub24iLCJpYXQiOjE3OTA5MzMwMTEsImV4cCI6MjEwNjUwOTAxMX0.DF-tKFR-BzujBRKgLKjVqAeyFAZjPVvYij1XDc3qlyU',
}

const PRODUCTION: SupabaseConfig = {
  url: 'https://odkgdixlgvjftimvdezw.supabase.co',
  anonKey:
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9ka2dkaXhsZ3ZqZnRpbXZkZXp3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3OTA5MzE3OTMsImV4cCI6MjEwNjUwNzc5M30.4a2c2afdpDVfSGUJ0mC-vbhvomjtuPxZ79Du0BkwKyk',
}

const LOCAL_URL = 'http://127.0.0.1:54321'

export const LOCAL_DB_MODE = 'localdb'

const local = (env: Record<string, unknown>): SupabaseConfig => {
  const anonKey = env.VITE_SUPABASE_ANON_KEY
  if (typeof anonKey !== 'string' || anonKey === '') {
    throw new Error(`Mode ${LOCAL_DB_MODE} needs VITE_SUPABASE_ANON_KEY: the local Supabase anon key, from \`supabase status -o env\``)
  }
  const url = env.VITE_SUPABASE_URL
  return { url: typeof url === 'string' && url !== '' ? url : LOCAL_URL, anonKey }
}

export const supabaseConfigFor = (mode: string, env: Record<string, unknown> = {}): SupabaseConfig => {
  if (mode === 'production') return PRODUCTION
  if (mode === LOCAL_DB_MODE) return local(env)
  return DEVELOPMENT
}
